import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { LogSeverity } from 'src/app/models/enums/log-severity';
import { LogSupervisionEntry } from 'src/app/models/log-supervision-entry';
import { LogSupervisionService } from 'src/app/services/log-supervision.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { AdvancedGridviewComponent } from '../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-log-supervision',
    templateUrl: './log-supervision.component.html',
    styleUrls: ['./log-supervision.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class LogSupervisionComponent extends DefaultListComponent<LogSupervisionEntry> implements OnInit {
    public logs: LogSupervisionEntry[];

    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    severityColumnValues: ListItem<string>[] = [
        new ListItem(LogSeverity.Alert.toString(), 'Alerte'),
        new ListItem(LogSeverity.Crit.toString(), 'Critique'),
        new ListItem(LogSeverity.Debug.toString(), 'Debug'),
        new ListItem(LogSeverity.Emerg.toString(), 'Urgence'),
        new ListItem(LogSeverity.Err.toString(), 'Erreur'),
        new ListItem(LogSeverity.Info.toString(), 'Info'),
        new ListItem(LogSeverity.Notice.toString(), 'Notification'),
        new ListItem(LogSeverity.Security.toString(), 'Sécurité'),
        new ListItem(LogSeverity.Session.toString(), 'Session'),
        new ListItem(LogSeverity.Warn.toString(), 'Avertissement'),
    ];

    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        private LogSupervisionService: LogSupervisionService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        this.tableConfig = [
            new ColumnDefinition('date', 'Date', ColumnType.Text, FilterType.Text, 1, 9, true),
            new ColumnDefinition('domain', 'Domaine', ColumnType.Text, FilterType.Text, 2, 7, true),
            new ColumnListDefinition('severity', 'Sévérité', FilterType.List, 3, 7, true, false, this.severityColumnValues),
            new ColumnDefinition('source', 'Source', ColumnType.Text, FilterType.Text, 4, 7, true),
            new ColumnDefinition('sessionId', 'SessionId', ColumnType.Numeric, FilterType.Numeric, 5, 15, true),
            new ColumnDefinition('userDisplayName', 'Utilisateur', ColumnType.Numeric, FilterType.Numeric, 6, 10, true),
            new ColumnDefinition('organizationId', 'Organisation', ColumnType.Numeric, FilterType.Numeric, 7, 7, true),
            new ColumnDefinition('message', 'Message', ColumnType.Numeric, FilterType.Numeric, 8, 38, true),
        ];
    }

    ngOnInit(): void {
        // this.LogSupervisionService.List(null, null, null, null, 0, 100).subscribe(
        //   x => {
        //     this.logs = x.value;
        //   }
        // );

        this.dataSource = new AdvancedDataSource(null, this.LogSupervisionService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('date', 'desc'), false);
    }
}
